import { connect } from "react-redux";

import ReportsView from "./view.jsx";

import {
  fetchSummaryDetails,
  fetchPerformanceSummaryDetails,
  updateFiltersInReports,
  saveFilter,
  fetchFilters,
  selectFilter,
  updateFilter,
  fetchFilter,
  fetchReportSummaryNudges
} from "../../redux/actions/reports.jsx";

import withUseHooks from "src/legacy/components/withUseHooks.jsx";

import { trackAdoptionMetricsForReportScreenView, trackAdoptionMetricsForReportsViewedEvent } from "src/legacy/redux/actions/adoption.jsx"; 

const mapStateToProps = (state, ownProps) => {
  return {
    account: {},
    accountSummary: state.legacyRootReducer.reports.summary.item,
    performanceSummary: state.legacyRootReducer.reports.performance.performanceSummary.item,
    reportSummary: state.legacyRootReducer.reports.reportSummary.item,
    filters: state.legacyRootReducer.reports.selection.filters || [],
    filtersList: state.legacyRootReducer.reports.filters.items || [],
    loadingFilters: state.legacyRootReducer.reports.filters.loading,
    hasMore: state.legacyRootReducer.reports.filters.loadMore,
    selectedFilter: state.legacyRootReducer.reports.filters.item || [],
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSummaryDetails: (filter) => {
      return dispatch(fetchSummaryDetails(filter));
    },
    fetchPerformanceSummaryDetails: () => {
      return dispatch(fetchPerformanceSummaryDetails());
    },
    updateFiltersInReports: (filters) => {
      return dispatch(updateFiltersInReports(filters))
    },
    saveFilter: (request) => {
      return dispatch(saveFilter(request))
    },
    fetchAllFilters: (page, limit) => {
      return dispatch(fetchFilters(page, limit))
    },
    selectFilter: (filter) => {
      return dispatch(selectFilter(filter))
    },
    fetchReportSummaryNudges: (nudgesType) => {
      return dispatch(fetchReportSummaryNudges(nudgesType))
    },
    updateFilter: (id, request) => {
      return dispatch(updateFilter(id, request))
    },
    fetchFilter: (id) => {
      return dispatch(fetchFilter(id))
    },
    trackAdoptionMetricsForReportScreenView: () => {
      return dispatch(trackAdoptionMetricsForReportScreenView())
    },
    trackAdoptionMetricsForReportsViewedEvent: () => {
      return dispatch(trackAdoptionMetricsForReportsViewedEvent())
    }

  };
};

const ReportsPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsView);

export default withUseHooks(ReportsPage);